import type { OnboardingScenarioProps } from '../model/types'
import { useBreakUpQuiz } from '../model/useBreakUpQuiz'
import { questions } from '../model/breakupQuiz'
import BreakUpIntroduction from './BreakUpIntroduction'
import BreakUpQuizResult from './BreakUpQuizResult'
import s from './BreakUpOnboarding.module.css'
import q from './BreakUpQuiz.module.css'

export default function BreakUpQuizOnboarding(props: OnboardingScenarioProps) {
  const flow = useBreakUpQuiz(props)
  const step = flow.introduction ? 1 : flow.result ? 3 : 2
  const question = flow.questionId ? questions[flow.questionId] : null
  return <div className={s.page}>
    <header className={s.header}><span className={s.brand}>Хьюмантек</span><span aria-live="polite">Шаг {step} из 3</span></header>
    <div className={s.progress} aria-hidden="true"><span style={{ width: `${step / 3 * 100}%` }} /></div>
    <main className={s.main}>
      <section className={`${s.card} ${q.screen}`} key={flow.screenKey} ref={flow.screenRef} tabIndex={-1}>
        {flow.introduction ? <BreakUpIntroduction {...flow} /> : flow.result ? <BreakUpQuizResult result={flow.result} /> : question && <>
          <p className={q.eyebrow}>Где я сейчас в расставании? · Вопрос {flow.answers.length + 1}</p>
          <h1>{question.title}</h1>
          <div className={q.answers}>{question.options.map((option, choice) => <button key={option} type="button" value={choice} onClick={flow.choose} disabled={props.submitting}>{option}<span aria-hidden="true">→</span></button>)}</div>
          <p className={q.disclaimer}>Не медицинский тест. Это способ бережно сориентироваться в происходящем.</p>
        </>}
      </section>
      {props.error && <p role="alert" className={s.error}>{props.error}</p>}
      <div className={s.actions}>
        {!flow.introduction && <button type="button" className={s.back} onClick={flow.back} disabled={props.submitting}>Назад</button>}
        {flow.introduction && <button type="button" className={s.next} onClick={flow.start} disabled={!flow.introduced || props.submitting}>Продолжить</button>}
        {!flow.introduction && flow.result && <button type="button" className={s.next} onClick={flow.complete} disabled={props.submitting}>{props.submitting ? 'Сохраняем…' : 'Сохранить и продолжить'}</button>}
      </div>
      {!flow.introduction && flow.result && <button type="button" className={q.restart} onClick={flow.restart} disabled={props.submitting}>Пройти квиз заново</button>}
    </main>
  </div>
}
